"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6973],{

/***/ 29137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Media_BuilderMediaEditor; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/context/CoreContext.js
var CoreContext = __webpack_require__(64178);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ./src/mosanic/items/ControlModal/Dialog.js
var Dialog = __webpack_require__(41145);
// EXTERNAL MODULE: ./src/mosanic/items/AdvancedLabel.js
var AdvancedLabel = __webpack_require__(51085);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/Core/Utils/SuccessAlert.js
var SuccessAlert = __webpack_require__(17980);
// EXTERNAL MODULE: ./src/components/Core/Utils/Alert.js
var Alert = __webpack_require__(70159);
;// CONCATENATED MODULE: ./src/components/Core/Utils/ErrorAlert.js


var ErrorAlert = function(param) {
    var errorMessage = param.errorMessage;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* Alert */.b, {
        message: errorMessage,
        type: "error"
    });
};

// EXTERNAL MODULE: ./src/mosanic/components/Media/MediaUploader.js + 4 modules
var MediaUploader = __webpack_require__(51138);
;// CONCATENATED MODULE: ./src/mosanic/components/Media/Editor.js




// import 'tui-image-editor/dist/tui-image-editor.css';




// import ImageEditor from '@toast-ui/react -image-editor';
var ImageEditor = null;
var lightTheme = {
    "menu.normalIcon.color": "#222",
    "menu.activeIcon.color": "#1976d2",
    "menu.disabledIcon.color": "#434343",
    "menu.hoverIcon.color": "#1976d2",
    "menu.backgroundColor": "#f4f7fa",
    "submenu.backgroundColor": "#f4f7fa",
    "submenu.normalIcon.color": "#444141",
    "submenu.activeIcon.color": "#1976d2",
    "common.bi.image": "https://uicdn.toast.com/toastui/img/tui-image-editor-bi.png",
    "common.backgroundImage": "./img/bg.png",
    "common.backgroundColor": "#fff",
    "common.border": "none"
};
var MediaEditor = function() {
    var coreContext = (0,react.useContext)(CoreContext/* default */.Z);
    var ref = (0,react.useState)(null), error = ref[0], setError = ref[1];
    var ref1 = (0,react.useState)(null), msg = ref1[0], setMsg = ref1[1];
    var editorRef = /*#__PURE__*/ react.createRef();
    var handleClickButton = function() {
        var editorInstance = editorRef.current.getInstance();
        editorInstance.flipX();
    };
    var ref2 = (0,react.useState)(false), modalStateManager = ref2[0], setModalStateManager = ref2[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                    onClick: function() {
                        return setModalStateManager(true);
                    },
                    size: "small",
                    variant: "outlined",
                    children: "Upload media"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
                    state: modalStateManager,
                    close: function() {
                        return setModalStateManager(false);
                    },
                    size: "xl",
                    fullWidth: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                            helpText: "From here you can view, load and open your pages.",
                            children: "Upload item"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaUploader["default"], {
                            showEditor: true,
                            maxNumber: 3
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                            onClick: function() {
                                return setModalStateManager(false);
                            },
                            size: "small",
                            children: "Close"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "DataList-alerts",
                    children: [
                        error && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorAlert, {
                            errorMessage: error
                        }),
                        msg && /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessAlert/* SuccessAlert */.I, {
                            successMessage: msg
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/mosanic/components/Media/BuilderMediaEditor.js






var BuilderMediaEditor = function() {
    var cContext = (0,react.useContext)(CoreContext/* default */.Z);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
        state: cContext.mediaEditor != null,
        close: function() {
            return cContext.setMediaEditor(null);
        },
        size: "lg",
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                helpText: "From here you can manage all your media assets.",
                children: "Media Editor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaEditor, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                onClick: function() {
                    return cContext.setMediaEditor(null);
                },
                size: "small",
                children: "Close"
            })
        ]
    });
};
/* harmony default export */ var Media_BuilderMediaEditor = (BuilderMediaEditor);


/***/ }),

/***/ 26973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "BuilderMedia": function() { return /* reexport */ Media_BuilderMedia; },
  "BuilderMediaEditor": function() { return /* reexport */ BuilderMediaEditor/* default */.Z; },
  "ListOfMedia": function() { return /* reexport */ ListOfMedia/* ListOfMedia */.L; },
  "MediaUploader": function() { return /* reexport */ MediaUploader["default"]; },
  "default": function() { return /* binding */ Media; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/mosanic/items/ControlModal/Dialog.js
var Dialog = __webpack_require__(41145);
// EXTERNAL MODULE: ./src/context/CoreContext.js
var CoreContext = __webpack_require__(64178);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/mosanic/components/Media/Resolvers/GetListOfMedia.js
var GetListOfMedia = __webpack_require__(36520);
// EXTERNAL MODULE: ./src/mosanic/hooks/useInspectedAttr.js
var useInspectedAttr = __webpack_require__(14675);
// EXTERNAL MODULE: ./src/mosanic/hooks/useFieldSource.js
var useFieldSource = __webpack_require__(68901);
;// CONCATENATED MODULE: ./src/mosanic/components/Media/BuilderMedia.js







var BuilderMedia = function() {
    var cContext = (0,react.useContext)(CoreContext/* default */.Z);
    var type = ((0,useInspectedAttr/* useInspectedAttr */.L)("type") || {
        type: null
    }).type;
    var ref = (0,useFieldSource/* useFieldSource */.k9)({
        // basePath: 'fields.[field]', 
        path: type === "video" ? "fields.videoUrl" : type === "image" ? "fields.imageUrl" : "data.image"
    }, false), source = ref.source, handler = ref.handler;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
        state: cContext.mediaModal,
        close: function() {
            return cContext.setMediaModal(false);
        },
        size: "md",
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GetListOfMedia/* GetListOfMedia */.h, {
                header: true,
                dialog: true,
                initiate: handler,
                upload: false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                onClick: function() {
                    return cContext.setMediaModal(false);
                },
                size: "small",
                children: "Close"
            })
        ]
    });
};
/* harmony default export */ var Media_BuilderMedia = (BuilderMedia);

// EXTERNAL MODULE: ./src/mosanic/components/Media/BuilderMediaEditor.js + 2 modules
var BuilderMediaEditor = __webpack_require__(29137);
// EXTERNAL MODULE: ./src/mosanic/components/Media/ListOfMedia.js + 5 modules
var ListOfMedia = __webpack_require__(65475);
// EXTERNAL MODULE: ./src/mosanic/components/Media/MediaUploader.js + 4 modules
var MediaUploader = __webpack_require__(51138);
;// CONCATENATED MODULE: ./src/mosanic/components/Media/index.js







/* harmony default export */ var Media = (Media_BuilderMedia);


/***/ }),

/***/ 14675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useInspectedAttr; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _redux_inspect_selector__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81903);
/* harmony import */ var _util_isEqual__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89450);
/* harmony import */ var _util_Obj__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62570);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64157);







var useInspectedAttr = function() {
    var attributes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "all";
    var item = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(_redux_inspect_selector__WEBPACK_IMPORTED_MODULE_1__/* .inspectedItemSelector */ .Gv, _util_isEqual__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
    var component = (item === null || item === void 0 ? void 0 : item.breakPoint) ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, item), {
        type: "screen"
    }) : item;
    if (attributes != "all" && Array.isArray(attributes)) {
        var selected = {};
        attributes.forEach(function(attribute) {
            if ((0,_util_Obj__WEBPACK_IMPORTED_MODULE_5__/* .hasAttr */ .B$)(component, attribute)) selected = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, selected), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, attribute, component[attribute]));
        });
        return selected;
    }
    return component;
};


/***/ })

}]);